import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { TaktIdProvider, createStormTaktId, Flex, ProgressIndicator, HelpTip } from '@amzn/storm-ui';
import { P as PrefixText, a as ProgressIndicatorWrapper } from './ProgressIndicatorAttribute.styles-4K-BkY9A.js';

const ProgressIndicatorAttribute = ({
  id,
  value = 0,
  prefixLabel,
  label,
  status = 'default',
  targetLine,
  helptipText = '',
  helptipTextPosition = 'top',
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('page-header-progress-indicator')
}, /*#__PURE__*/React__default.createElement(Flex, {
  justifyContent: "flex-start",
  alignItems: "center",
  columnGap: "xxxsmall"
}, prefixLabel && /*#__PURE__*/React__default.createElement(PrefixText, null, prefixLabel, ":"), /*#__PURE__*/React__default.createElement(ProgressIndicatorWrapper, _extends({}, rest, {
  id: id
}), /*#__PURE__*/React__default.createElement(ProgressIndicator, _extends({
  value: value,
  status: status,
  inline: true,
  size: "large"
}, targetLine ? {
  targets: [targetLine]
} : undefined))), label && (label === null || label === void 0 ? void 0 : label(value)), !!helptipText && /*#__PURE__*/React__default.createElement(HelpTip, {
  position: helptipTextPosition
}, helptipText)));

export { ProgressIndicatorAttribute as P };
//# sourceMappingURL=ProgressIndicatorAttribute-BgyzfIRm.js.map
